import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentSegment } from "../../store/reducers/dadosSegmentos";

export default function RowRadioButtonsGroup({
  title,
  label,
  selecionado,
  disabled = false,
  disabledOptions = [],
}) {
  const [value, setValue] = React.useState(selecionado.title);
  const slices = useSelector((state) => state);
  const segmentos = { ...slices.dadosSegmentos.segmentos };
  const dispatch = useDispatch();
  
  const handleChange = (event) => {
    setValue(event.target.value);
    const newValue = event.target.value;
    label.forEach((element) => {
      if (element.title === newValue) {
        const code = element.code;
        mandar(code, newValue);
      }
    });
  };
  
  useEffect(() => {
    if (selecionado.title !== value) {
      setValue(selecionado.title);
    }
  }, [selecionado]);

  function mandar(code, value) {
    const obj = {
      title: title,
      selecionado: { title: value, code: code },
    };
    dispatch(setCurrentSegment(obj));
  }

const shouldDisableOption = (optionCode) => {
  // Bloqueio global: desabilita absolutamente tudo
  if (disabled) {
    return true;
  }

  // Bloqueio específico do campo
  return disabledOptions.includes(optionCode);
};

  const shouldHideOption = (optionTitle, optionCode) => {
    if (optionTitle.includes("Não se aplica")) {
      const notApplicableOption = label.find(item => item.title.includes("Não se aplica"));
      
      if (notApplicableOption) {
        return selecionado.code !== notApplicableOption.code;
      }
    }
    return false;
  };

  // const isNotApplicableAutoSelected = () => {
  //   const notApplicableOption = label.find(item => item.title.includes("Não se aplica"));
  //   return notApplicableOption && selecionado.code === notApplicableOption.code;
  // };

  return (
    <FormControl>
      <FormLabel id="demo-row-radio-buttons-group-label">{title}</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={value}
        onChange={handleChange}
      >
        {label.map((labelItem) => {
          if (shouldHideOption(labelItem.title, labelItem.code)) {
            return null;
          }
          
          const isOptionDisabled = shouldDisableOption(labelItem.code);
          
          return (
            <FormControlLabel
              key={labelItem.title}
              disabled={isOptionDisabled}
              value={labelItem.title}
              control={<Radio />}
              label={labelItem.title}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
}